import { ReactNode, RefObject } from "react";
import Rows from "../../../library/components/layout/Rows";
import Columns from "../../../library/components/layout/Columns";
import { PDF_CANVAS_WIDE_SIDEBAR_WIDTH } from "./pdfCanvasConstants";

export type PdfDisplayerLayoutVariant = "wide" | "stacked";

interface IPdfDisplayerLayoutProps {
    variant: PdfDisplayerLayoutVariant,
    containerRef: RefObject<HTMLDivElement>,
    pdfScrollArea: ReactNode,
    wideSidebar: ReactNode,
    stackedToolbar: ReactNode,
    stackedPanels: ReactNode,
}

const PdfDisplayerLayout = (props: IPdfDisplayerLayoutProps) => {
    if (props.variant === "wide") {
        return <Rows forwardRef={props.containerRef} flex width="100%" height="100%" style={{ minHeight: 0 }} gap={0} mt={10}>
            <Columns flex width="100%" height="100%" dontGrowForChild style={{ minHeight: 0, alignItems: "stretch" }}>
                <Rows
                    width={PDF_CANVAS_WIDE_SIDEBAR_WIDTH}
                    height="100%"
                    dontGrowForChild
                    gap={30}
                    p={8}
                    style={{ flexShrink: 0, minHeight: 0, overflow: "hidden" }}>
                    {props.wideSidebar}
                </Rows>
                {props.pdfScrollArea}
            </Columns>
        </Rows>;
    }

    return <Rows dontGrowForChild forwardRef={props.containerRef} flex width="100%" style={{ minHeight: 0 }} gap={10} mt={10}>
        {props.stackedToolbar}
        {props.stackedPanels}
        {props.pdfScrollArea}
    </Rows>;
};

export default PdfDisplayerLayout;
